import React from 'react';
import _ from 'lodash';
import {formValueSelector} from 'redux-form';

import Warning from 'components/Warning';
import FormField from 'components/FormField';
import Label from 'components/Label';
import {SelectRoomTypeField} from 'components/Fields';
import {buildRoomTypeSelectizeOption} from 'components/Fields/SelectRoomTypeField';

import {headOption} from 'utils/common';
import {selectModal, MODALS as BASE_MODALS} from 'ducks/modals';

import './styles.css';

const formSelector = formValueSelector('createBookingExtension');

export const initialValues = state => {
  const modal = selectModal(state, BASE_MODALS.CREATE_BOOKING);

  const groupedRoomType = _.get(modal, 'data.roomTypes', []);

  const roomTypes = _.flatten(
    groupedRoomType.map(roomTypeGroup => roomTypeGroup.roomTypes)
  );

  const selectedBookingValue = formSelector(state, 'booking');
  const roomTypeId = _.get(selectedBookingValue, 'object.room.roomType.id');

  const selectedRoomType = headOption(
    roomTypes.filter(option => _.get(option, 'id') === roomTypeId),
    buildRoomTypeSelectizeOption
  );

  return {
    roomType: selectedRoomType
  };
};

const DIFFERENT_ROOM_TYPE_FROM_BOOKINGS_ROOM_TYPE_WARNING =
  "You have selected different room type to the member's current room type!";

const RoomTypeSection = ({roomTypes, onRoomTypeChange, differentRoomType}) => (
  <div className="RoomTypeSection">
    <FormField>
      <Label>Room type</Label>
      <SelectRoomTypeField
        groupedRoomTypes={roomTypes}
        onChange={onRoomTypeChange}
      />
      {differentRoomType && (
        <Warning>{DIFFERENT_ROOM_TYPE_FROM_BOOKINGS_ROOM_TYPE_WARNING}</Warning>
      )}
    </FormField>
  </div>
);

export default RoomTypeSection;
